/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ModelError {
    getFixupPrototypeFunction() { return ModelError.fixupPrototype; }

    static newInstance(model: Partial<ModelError>): ModelError {
        let obj = Object.assign(new ModelError(), model);
        ModelError.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ModelError>): ModelError {
        if (!model) return null;
        return ModelError.newInstance(<ModelError> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ModelError) {
        if (!obj) return;

        models.ModelError.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ModelError): boolean {
        Object.setPrototypeOf(obj, ModelError.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Error response message.
     */
    message: string;

}
